module.exports = __webpack_public_path__ + "img/logo.060dc084.png";